import VendorManageInventory from "./Default/VendorManageInventory";

export default VendorManageInventory;

